import { Component} from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BaseWidget } from 'src/app/tools/abstract-classes/base-widget';
import { MasterDataService } from 'src/app/assabil-kernel/services/master-data-service';
import { LeanUtilsService } from 'src/app/tools/services/lean-utils-service';
import { Itinerary } from 'src/app/assabil-kernel/models/entities/master-data/itinerary-entity';
import { Partner } from 'src/app/assabil-kernel/models/entities/master-data/partner-entity';
import { PartnerLovComponent } from '../partner-lov/partner-lov.component';
import { ItineraryPartner } from 'src/app/assabil-kernel/models/entities/master-data/itinerary-partner-entity';
import { marker } from 'src/app/tools/models/entities/marker';
import { MyLocation } from 'src/app/tools/models/entities/my-location';
import { MatDialog } from '@angular/material/dialog';

@Component({
    selector: 'itinerary-widget',
    templateUrl: './itinerary-widget.component.html',
    styleUrls: ['./itinerary-widget.component.scss']
})

export class ItineraryWidgetComponent extends BaseWidget {

  itinerary                   : Itinerary = new Itinerary();
  

  constructor(
      protected masterDataService   : MasterDataService,
      protected toastr              : ToastrService,
      protected dialog              : MatDialog,
      protected leanUtilsService    : LeanUtilsService) {
      super(toastr, leanUtilsService);

      this.entityName = "itinerary";
  }
//---------------------------------------------------------------------------------------


//---------------------------------------------------------------------------------------
setEntity(itinerary: Itinerary) {
      this.itinerary  = { ...itinerary };
      this.itinerary.itineraryPartners = [];
      if (itinerary.itineraryPartners) {
        for (let itineraryPartner of itinerary.itineraryPartners) {
          this.itinerary.itineraryPartners.push({ ...itineraryPartner });
        }
      }
  }
//---------------------------------------------------------------------------------------


//---------------------------------------------------------------------------------------
  getEntity(){
    return this.itinerary;
  }
//---------------------------------------------------------------------------------------


//---------------------------------------------------------------------------------------
  saveRow() : Promise<Itinerary>{
    return this.masterDataService.itinerarySave(this.itinerary);
  }
//---------------------------------------------------------------------------------------



//-----------------------------------------------------------------------------------------------------------------------------
partners : Partner[];
new(){
  let dialogRef = this.dialog.open(PartnerLovComponent, {autoFocus: false,  hasBackdrop : false, data : {dual: true, partners  : this.partners}});
  dialogRef.afterClosed().subscribe(result => {
    if(result){
      this.partners = result.partners;
      if (result.selectedPartners) this.addPartners(result.selectedPartners);
    }
  });
}
//-----------------------------------------------------------------------------------------------------------------------------


//-----------------------------------------------------------------------------------------------------------------------------
addPartners(partners : Partner[]){
  for (let tmp of partners){

    // Np need to send all partner data to the server
    //------------------------------------
      let partner : Partner = new Partner();
      partner.partnerCode = tmp.partnerCode;
      partner.name = tmp.name;
   //------------------------------------
 
      let nr = new ItineraryPartner();
      nr.inserted             = true;
      nr.edit                 = true;
      nr.partner              = partner;
      nr.rank                 = 0;
      this.itinerary.itineraryPartners.push(nr);
  }
  this.itinerary.itineraryPartners = [...this.itinerary.itineraryPartners];  
}
//-----------------------------------------------------------------------------------------------------------------------------



//---------------------------------------------------------------------------------------
showInMap : boolean = false;
  map(show : boolean){
    if (! show){
      this.showInMap = false;
      return;
    }
    this. buildPoints();
    this.showInMap = true;
  }

  points : marker[] = [];
  
  origin      : marker;
  destination : marker;
  waypoints   : MyLocation[] = [];

  buildPoints(){


  //  this.pointEs : Marker[this.branchs.length];
    let i : number = 0;
    let index : number = 1;
    this.itinerary.itineraryPartners.forEach(itineraryPartner => {

      let colors = '|2EBD07|FFFFFF';
      let icon = 'https://chart.googleapis.com/chart?chst=d_map_pin_letter&chld=' + (index++)+ colors;

      let point : marker = {     
        lat: itineraryPartner.partner.latitude,
        lng: itineraryPartner.partner.longitude,
        label:itineraryPartner. partner.name,
        draggable: false,
        iconUrl: icon
   //     iconUrl: 'http://maps.google.com/mapfiles/ms/icons/green.png'
  };
    
      if (! this.origin) this.origin = point;
      this.destination = point;

      let wp : MyLocation = {
        location : {
          lat :  itineraryPartner.partner.latitude,
          lng : itineraryPartner.partner.longitude,
        }
      }
      this.waypoints.push(wp);

      this.points.push(point);
    })
  }  
  //---------------------------------------------------------------------------------------

  showMapF(){}
}
